"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Modal;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ModalContent = _interopRequireDefault(require("Modals/ModalTools/ModalContent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function Modal({
  children,
  afterHidden,
  ...props
}) {
  const [trg, setTrg] = (0, _react.useState)();
  const [visible, setVisible] = (0, _react.useState)(props.open === true);
  (0, _react.useEffect)(function () {
    if (props.open === true && !visible) setVisible(true);
    if (props.trg && props.trg !== trg) {
      setTrg(props.trg);
    }
  }, [props.open, props.trg, visible, trg]);
  (0, _react.useEffect)(function () {
    // give back the focus to where it was before opening the modal
    if (!visible && trg && typeof trg.focus === 'function') trg.focus();
    if (!visible) setTrg(undefined);
  }, [visible, trg]);
  const handleAnimationEnd = (0, _react.useCallback)(function (e) {
    setVisible(props.open === true);
    if (typeof afterHidden === 'function' && props.open !== true) {
      afterHidden();
    }
  }, [props.open, afterHidden]);
  const output = props.open || visible ? /*#__PURE__*/_react.default.createElement(_ModalContent.default, {
    onClose: props.onClose,
    footer: props.footer,
    onAnimationEnd: handleAnimationEnd,
    open: props.open === true,
    "prevent-close": props['prevent-close'] === true,
    "close-classes": props['close-classes'],
    "close-label": props['close-label'],
    title: props.title,
    bemit: props.bemit,
    "scroll-area": props['scroll-area'],
    "hide-footer": props['hide-footer'],
    "hide-header": props['hide-header'],
    "prevent-bg-close": props['prevent-bg-close']
  }, children) : undefined;
  return /*#__PURE__*/_reactDom.default.createPortal(output, document.body);
}
